import { ToggleChipProps } from './ToggleChip.types';
import { useState } from 'react';
import { StyledChip } from './ToggleChip.styles';

const ToggleChip = ({
  label,
  defaultValue,
  value,
  onClick,
  disabled,
  readonly
}: ToggleChipProps) => {
  const [active, setActive] = useState(defaultValue);

  const toggle = () => {
    setActive(!active);

    onClick(!active);
  };

  return (
    <StyledChip
      disabled={disabled}
      label={label}
      readonly={readonly}
      variant={active || value ? 'filled' : 'outlined'}
      onClick={toggle}
    />
  );
};

export default ToggleChip;
